import { render, staticRenderFns } from "./Charter.vue?vue&type=template&id=aa6b0968&"
import script from "./Charter.vue?vue&type=script&lang=js&"
export * from "./Charter.vue?vue&type=script&lang=js&"
import style0 from "./Charter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports